"use client";
import React from "react";
import AiTop from "@/components/ai/aiAgent/AiTop";
import AiToolsFaq, {
  IFaqList,
} from "@/components/tools/ToolsCommon/AiToolsFaq";
import { StaticImageData } from "next/image";
import AdBanner from "@/components/Advertisement/AdBanner";
import Achievements from "@/components/home/Certifications/Achievements";
import WorkAi from "@/components/features/WorkAi";
import AIGridBox from "@/components/ai/aiAgent/AIGridBox";
import BuiltCards from "@/components/features/BuiltCards";

export interface ItemInfoProps {
  contextualTag: string;
  introText: React.ReactNode;
  descriptionText: string;
  bannerImg?: StaticImageData;
}

export type WorkAiType = {
  contextualTag: string;
  title: React.ReactNode;
  description: string;
  image: StaticImageData;
};

export type GridItemType = {
  title: string;
  description: string;
  image?: StaticImageData;
  large?: boolean;
};

export type GridSectionInfoType = {
  tag: string;
  heading: React.ReactNode;
  subheading?: string;
  theme?: "white" | "gray" | "hasImage";
  backgroundImage?: StaticImageData;
  gridAreaInfo: GridItemType[];
};


export type TAIPropTypes = {
  params: {
    itemInfo: ItemInfoProps;
    workAi: WorkAiType;
    gridSectionInfo: GridSectionInfoType[];
    gridSectionInfo2: GridSectionInfoType[];
    gridSectionInfo3: GridSectionInfoType[];
    gridSectionInfo4: GridSectionInfoType[];
    gridSectionInfo5: GridSectionInfoType[];
    faqList: IFaqList[];
  };
};

const AiAgentPageRoot = ({ params }: TAIPropTypes) => {
  const {
    itemInfo,
    workAi,
    gridSectionInfo,
    gridSectionInfo2,
    gridSectionInfo3,
    gridSectionInfo4,
    gridSectionInfo5,
    faqList,
  } = params;

  return (
    <>
      <AiTop itemInfo={itemInfo} />
      <WorkAi workAiInfo={workAi} />
      <AIGridBox sections={gridSectionInfo} />
      <AIGridBox sections={gridSectionInfo2} />
      <AIGridBox sections={gridSectionInfo3} />
      <AIGridBox sections={gridSectionInfo4} />
      <AIGridBox sections={gridSectionInfo5} />
      <Achievements />
      <BuiltCards />
      <AdBanner title={<>Deploy your first<br /><span className="bg-gradient-to-r from-[#781E8F] to-[#422CBB] bg-clip-text text-transparent">AI Agent today</span></>} btnText="Get Started Free" twoButtons={true} />
      <AiToolsFaq faqTitle="Everything leaders ask before rolling out AI Agents." faqList={faqList} />
    </>
  );
};

export default AiAgentPageRoot;
